import React, { useState } from 'react';
import './Slider.css';

const SliderRow1 = () => {
  const [sliderValue, setSliderValue] = useState(0);
  const [hoveredValue, setHoveredValue] = useState(0);

  const handleChange = (event) => {
    const newValue = parseInt(event.target.value, 10);
    setSliderValue(newValue);
    setHoveredValue(newValue);
  };

  const handleMouseEnter = (value) => {
    setHoveredValue(value);
  };

  const handleMouseLeave = () => {
    setHoveredValue(sliderValue);
  };

  const handleMouseMove = (event) => {
    // Calculate the slider value based on the mouse position within the slider track
    const slider = document.querySelector('.slider');
    const sliderWidth = slider.clientWidth;
    const mouseX = event.clientX - slider.getBoundingClientRect().left;
    const newValue = Math.round((mouseX / sliderWidth) * 10);

    if (newValue !== sliderValue) {
      setSliderValue(newValue);
    }
  };

  const getImages = () => {
    const images = [];
    for (let i = 1; i <= 10; i++) {
      images.push(
        <div
          key={i}
          className={`slider-image ${i === hoveredValue ? 'hovered' : ''}`}
          onMouseEnter={() => handleMouseEnter(i)}
          onMouseLeave={handleMouseLeave}
        >
          <a href={`https://tokens.freeweb3.com`} target="_blank" rel="noopener noreferrer"> 
            {i === hoveredValue ? (
              <img src={`images/medium2/image${i}_medium.png`} alt={`LexAutomatico Reward ${i}`} className="medium" />
            ) : (
              <div>
                <img src={`images/thumbnail/image${i}_thumbnail.png`} alt={`LexAutomatico Reward ${i}`} />
                <p>Reward {i}</p>
              </div>
            )}
          </a>
        </div>
      );
    }
    return images;  
  };

  return (
    <div className="slider-container">
      <div className="images" onMouseMove={handleMouseMove}>
        {getImages()}
      </div>
      <div className="larger-image">
        {hoveredValue !== null && (
          <img src={`images/large/image${hoveredValue}_large.png`} alt={`LexAutomatico Reward ${hoveredValue}`} />
        )}
      </div>
      <input
        type="range"
        min="0"
        max="10"
        step="1"
        value={sliderValue}
        onChange={handleChange}
        className="slider"
      />
    </div>
  );
};

export default SliderRow1;
